export const THEMES = {
  cozy_cork: {
    key: "cozy_cork",
    name: "Cozy Cork",
    desc: "Warm honey cork, walnut frame",
    board: "radial-gradient(circle at 30% 20%, rgba(255,240,200,.35), transparent 60%), url('https://images.unsplash.com/photo-1558051815-0f18e64e6280?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600')",
    frame: "#5c4033",
    swatch: "#c19a6b",
    dark: false,
    pin: "thumbtack",
  },
  fridge_door: {
    key: "fridge_door",
    name: "Fridge Door",
    desc: "Brushed steel, magnet chips",
    board: "repeating-linear-gradient(90deg,#d7dadd 0px,#c9ccd0 2px,#d7dadd 4px), linear-gradient(180deg,#e6e8ea,#c3c6c9)",
    frame: "#8a8f94",
    swatch: "#c9ccd0",
    dark: false,
    pin: "magnet",
  },
  kids_room: {
    key: "kids_room",
    name: "Kids Room",
    desc: "Bright pastels, crayon doodles",
    board: "linear-gradient(135deg,#ffd3e0,#c8f0ff 45%,#fff4b8)",
    frame: "#ff8fb1",
    swatch: "#ffd3e0",
    dark: false,
    pin: "thumbtack",
  },
  office_minimal: {
    key: "office_minimal",
    name: "Office Minimal",
    desc: "Clean whiteboard, monochrome",
    board: "linear-gradient(180deg,#fbfbfc,#eef0f2)",
    frame: "#3a3d42",
    swatch: "#f4f5f6",
    dark: false,
    pin: "magnet",
  },
  late_night: {
    key: "late_night",
    name: "Late Night",
    desc: "Dark mood, desk lamp glow",
    board: "radial-gradient(circle at 70% 15%, rgba(255,214,140,.28), transparent 45%), linear-gradient(180deg,#242028,#15121a)",
    frame: "#0c0a10",
    swatch: "#2a2530",
    dark: true,
    pin: "thumbtack",
  },
};

export const themeList = Object.values(THEMES);
export const getTheme = (k) => THEMES[k] || THEMES.cozy_cork;
